export default __webpack_public_path__ + "static/media/SHEEP.977929bd.gif";